module.exports = __webpack_public_path__ + "img/forgot-pass-icon.393c17c4.svg";